// frontend/src/pages/PayrollDrafts/helpers.ts
// Pure helpers: no React, no state, no DOM. Trivially unit-testable.

/**
 * Format an ISO date as dd/mm/yyyy. Returns empty string on invalid or missing input.
 */
export function fmtDate(iso?: string | null): string {
  if (!iso) return "";
  const d = new Date(iso);
  if (isNaN(d.getTime())) return iso;
  const dd = String(d.getUTCDate()).padStart(2, "0");
  const mm = String(d.getUTCMonth() + 1).padStart(2, "0");
  return dd + "/" + mm + "/" + d.getUTCFullYear();
}

/**
 * Format an amount as en-CA money with 2 decimals.
 * Accepts number, numeric string, or null/undefined.
 */
export function fmtMoney(v: number | string | null | undefined): string {
  const n = Number(v || 0);
  return "$" + n.toLocaleString("en-CA", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}

/**
 * Bearer-token auth headers for apiFetch calls that do not send a body.
 * (DELETE requests, etc.) Reads either `access_token` or legacy `token`.
 */
export function authHeaders(): Record<string, string> {
  const t =
    localStorage.getItem("access_token") ||
    localStorage.getItem("token") ||
    "";
  return { Authorization: "Bearer " + t };
}